module.exports = __webpack_public_path__ + "img/fire.2e8d637e.svg";